let el = null
let timer = null

function ensureEl() {
  if (el) return el
  el = document.createElement('div')
  el.className = 'og-toast'
  el.setAttribute('role', 'status')
  document.body.appendChild(el)
  return el
}

function show(message, type) {
  const node = ensureEl()
  node.textContent = String(message || '')
  node.dataset.type = type || 'info'
  node.classList.add('is-show')
  clearTimeout(timer)
  timer = setTimeout(() => {
    node.classList.remove('is-show')
  }, 2800)
}

export function showSuccessToast(msg) {
  show(msg, 'ok')
}

export function showErrorToast(msg) {
  show(msg, 'err')
}
